<template>
  <InputAutoDinamico
    ref="sug"
    v-model="selected"
    :template="template"
    :scope="scope"
    :errorsBag="errorsBag"
    :label="label"
    :name="name"
    :isLoading="isLoading"
    :sugestoes="sugestoes"
    :disabled="habilitarCampo()"
    :camposMostrarInput="['nome', 'contato']"
    :camposFiltrar="['nome', 'contato']"
    :erroConexao="erroConexao"
    :rotaTelaCadastro="'rota-clientes-cadastro'"
    separador=" - "
    msgSemRegistros='Não há clientes cadastrados...'
    @buscarMaisRegistros="buscarMaisRegistros" />
</template>

<script>
import InputAutoDinamico from '@/components/inputs/autocomplete/InputAutoDinamico.vue'
import InputAutoMixin from '@/components/inputs/autocomplete/InputAutoMixin'

import TemplateCliente from './templates/TemplateCliente.vue'
import ClienteService from '../../../services/clientes.service'

export default {
  name: 'InputSugestaoFilial',
  mixins: [InputAutoMixin],
  components: {
    InputAutoDinamico,
  },
  data() {
    return {
      template: TemplateCliente,
    }
  },
  methods: {
    // eslint-disable-next-line
    async carregaTudo() {},
    async buscarMaisRegistros(filtro) {
      try {
        this.erroConexao = false
        this.isLoading = true
        const retorno = await ClienteService.retornaTodosPorFiltro(filtro)
        this.sugestoes = retorno.lista
      } catch (error) {
        this.erroConexao = error.tipo === 'MSG_ERRO'
        this.sugestoes = []
      } finally {
        this.isLoading = false
      }
    },
  },
}

</script>
